import { render, staticRenderFns } from "./ElegirAgricultor.vue?vue&type=template&id=a9721794&scoped=true&"
import script from "./ElegirAgricultor.vue?vue&type=script&lang=js&"
export * from "./ElegirAgricultor.vue?vue&type=script&lang=js&"
import style0 from "./ElegirAgricultor.vue?vue&type=style&index=0&id=a9721794&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9721794",
  null
  
)

export default component.exports